import { Component, OnChanges, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filter, first, takeUntil } from 'rxjs';
import {
  ButtonsComponent,
  CheckoutConfigService,
  NavbarCartService,
  GungModalService,
  SaveCartModalConfigService,
  CartService,
  AuthService,
  SelectedCustomerService,
  GungFlowService,
  PriceService,
  CartsService
} from 'gung-standard';
import { CarLinerBrochuresHelperService } from '../../services/car-liner-brochures-helper.service';
import { CarLinerSaveCartModalConfigService } from '../../services/car-liner-save-cart-modal-config.service';
import { GungCurrencyPipe } from 'gung-standard';
import { CarLinerMysetupService } from '../../services/car-liner-mysetup.service';
import { CarLinerDeliveryLocationsJeevesComponent } from '../car-liner-delivery-locations-jeeves/car-liner-delivery-locations-jeeves.component';

@Component({
    selector: 'car-liner-buttons',
    templateUrl: './car-liner-buttons.component.html',
    styleUrls: ['./car-liner-buttons.component.scss'],
    standalone: false
})
export class CarLinerButtonsComponent extends ButtonsComponent implements OnInit, OnChanges {
  isUserDistributor: boolean;
  isAdmin = false;
  isOrder = false;
  isEndUser = false;
  cartTotalWithoutDiscountValue: number;
  cartTotalValue: number;
  cartTotalWithVat: number;
  cartVat = 0;
  cartVatValue = 0;
  cartTotalNet = 0;

  public hasRoleOrder: boolean;
  public isVatSelected: boolean = true;
  public vatGst: string = 'VAT';

  constructor(
    protected navbarCartService: NavbarCartService,
    protected gungModalService: GungModalService,
    protected saveCartModalConfigService: CarLinerSaveCartModalConfigService,
    protected cartService: CartService,
    protected translationService: TranslateService,
    protected authService: AuthService,
    protected checkoutConfig: CheckoutConfigService,
    protected selectedCustomerService: SelectedCustomerService,
    protected gungFlowService: GungFlowService,
    protected priceService: PriceService,
    protected carLinerBrochuresHelperService: CarLinerBrochuresHelperService,
    protected currencyPipe: GungCurrencyPipe,
    protected carLinerMysetupService: CarLinerMysetupService,
    protected cartsService: CartsService
  ) {
    super(
      navbarCartService,
      gungModalService,
      saveCartModalConfigService,
      cartService,
      translationService,
      authService,
      checkoutConfig,
      cartsService
    );
  }

  ngOnInit(): void {
    this.updateData();

    this.authService
      .getRoles()
      .pipe(
        filter(roles => !!roles),
        first()
      )
      .subscribe(roles => {
        this.isSales = roles.filter(role => role.toUpperCase() === 'SALES').length > 0;
        this.hasRoleOrder = roles.indexOf('ORDER') > -1;
      });

    this.carLinerMysetupService
      .getMySetup()
      .pipe(first())
      .subscribe(setup => {
        this.navbarCartService
          .getContents()
          .pipe(takeUntil(this.unsubscribe))
          .subscribe(contents => {
            this.cartContents = contents;
            this.cartTotalValue = Number(contents.totalValue.toFixed(2));
            this.cartTotalWithVat = Number(this.cartTotalValue.toFixed(2));

            this.cartCurrency = contents.currency;
            this.cartTotalRows = contents.rows.length;
            this.cartTotalItems = contents.rows.map(row => row.cartRow.qty).reduce((acc, curr) => acc + curr, 0);
            this.cartTotalWithoutDiscountValue = contents.rows.reduce(
              (accumulator, currentValue) => accumulator + currentValue.price.cartRowTotalPrice.value,
              0
            );
            this.cartTotalNet = contents.rows.reduce(
              (accumulator, currentValue) => accumulator + currentValue.price.customerNetPrice.value * currentValue.cartRow.qty,
              0
            );
            if (this.currentStep === CarLinerDeliveryLocationsJeevesComponent && setup.markUp) {
              this.cartTotalWithoutDiscountValue = contents.rows.reduce(
                (accumulator, currentValue) =>
                  accumulator +
                  (currentValue.cartRow.extra.orp.vb_pris / (1 + setup.markUp / 100)) * currentValue.cartRow.qty,
                0
              );

              this.cartTotalValue = contents.rows.reduce((accumulator, currentValue) => {
                let originalTotalPrice =
                  accumulator + currentValue.price.cartRowTotalPrice.value * currentValue.cartRow.qty;
                if (!currentValue.cartRow?.extra?._userChangePrice) {
                  originalTotalPrice =
                    (currentValue.cartRow.extra.orp.vb_pris / (1 + setup.markUp / 100)) * currentValue.cartRow.qty;
                }

                if (currentValue.cartRow.extra.orp.rabatt1) {
                  originalTotalPrice =
                    originalTotalPrice - (originalTotalPrice * currentValue.cartRow.extra.orp.rabatt1) / 100;
                }
                return accumulator + originalTotalPrice;
              }, 0);
            }
            this.updateVat(this.cartVat);
          });
      });

    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isAdmin = roles.indexOf('ADMIN') > -1;
        this.isUserDistributor = roles.indexOf('USER') > -1 && roles.indexOf('DISTRIBUTOR') > -1;
        this.isEndUser = roles.indexOf('END_USER') > -1;
      });
  }

  createQuotation(): void {
    this.saveCartModalConfigService.carLinerOpenCreateQuotationModal(
      this.cartVat,
      this.cartTotalWithVat,
      this.cartVatValue,
      this.isVatSelected
    );
  }

  getVatValueCurrency(currency: string) {
    return this.currencyPipe.transform(this.cartVatValue, currency || 'SEK');
  }

  vatSelectOption(option) {
    this.isVatSelected = option === 'VAT';
  }

  updateVat(event) {
    if (event == null) {
      this.cartVat = 0;
      this.cartVatValue = 0;
      this.cartTotalWithVat = this.cartTotalValue;
      return;
    }
    this.cartVatValue = this.cartTotalValue * (event / 100);
    this.cartVat = event;
    this.cartTotalWithVat = this.cartTotalValue * (1 + event / 100);
  }

  checkNextBtnDisabled() {
    return (
      this.cartContents?.rows
        .map(r => this.carLinerBrochuresHelperService.getBrochuresById(r.product.id))
        ?.filter(b => b && !b.decision)?.length > 0
    );
  }

  updateData() {
    super.updateData();
  }
}
